import React, { Component } from 'react'
import { Meta, getmeta, Feature, collectFeatureOptions, createDefaultFeatureLabel, valueByFormikPath } from '../../common'
import { withTranslation, WithTranslation } from 'react-i18next'
import { Grid } from 'semantic-ui-react'
import Dropdown from './Dropdown'
import DatePicker from './DatePicker'
import Checkbox from './Checkbox'
import { sourceMapsEnabled } from 'node:process'

interface AdvancedQueryProps extends WithTranslation {
    meta: Meta,
    formik: any,
    prefix: string,
    params: any,
    featureTypeParams?: any,
    label?: string|null,
    cunitTypes?: string[]|null
}

class AdvancedQuery extends Component<AdvancedQueryProps> {
    
    withPrefix(fieldName: string) {
        return `${this.props.prefix}.${fieldName}`
    }

    render() {
        const { params, featureTypeParams, formik, cunitTypes, meta, t } = this.props
        const userOptions = [
            {key: '', value: '', text: ''},
            ...meta.user.grpmembers.map((m) => ({key: m.id, value: m.id, text: [m.firstname, m.surname].join(" ")}))
        ]

        if (cunitTypes && !cunitTypes.some(u => meta.cats['cunit'][u]['_can_write']))
            return null
        
        return(
            <React.Fragment>
            <Grid.Row verticalAlign="middle">
                <Grid.Column width={2}></Grid.Column>
                <Grid.Column width={2}>
                    {featureTypeParams ? ['cunits', 'slots', 'fillers'].map((o) =>  {
                        return (<Checkbox name={this.withPrefix('within')} value={o} label={t(o)}
                            inputProps={{disabled: featureTypeParams.within && !featureTypeParams.within.contains(o)}}
                            fieldProps={{className: "compactfield"}}/>)
                    }) : null}
                </Grid.Column>
                <Grid.Column width={4}>
                    { params.advanced.updated_by ? (
                        <Dropdown label={t('Last update by')} name={this.withPrefix('updated_by')} options={userOptions} inputProps={{compact: true}}/>
                    ) : null }
                </Grid.Column>
                { params.advanced.updated_on ? (
                    <>
                    <Grid.Column width={4}>
                    <DatePicker label={t('from')} name={this.withPrefix('updated_on_from')}/>
                    </Grid.Column>
                    <Grid.Column width={4}>
                    <DatePicker label={t('to')} name={this.withPrefix('updated_on_to')}/>
                    </Grid.Column>
                    </>
                ) : null }
            </Grid.Row>
            </React.Fragment>
        )
    }

}

export default withTranslation()(AdvancedQuery)